
import React, { useContext, useEffect, useRef, useState } from "react";

import { Button, Col, Modal, Row, Typography } from "antd";
import { CalendarOutlined, DollarOutlined, PhoneOutlined, CheckCircleTwoTone, PhoneFilled } from "@ant-design/icons";

import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { Grid } from "antd";
import { LeadButtons } from "../LeadButtons/web";
import { RTBhouse } from "../../../RTBhouse/web";
import { Rule } from "antd/lib/form";
import SimilarsLead from "../SimilarsLead/web";
import cookie from "js-cookie";
import { isValidCharactersXSS } from "../../../../Utils/Functions";
import { openAuthModal } from "../../../../Components/User/AuthModal/openAuthModal";
import { useContact } from "../hook";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { useTheme } from "../../../../Styles/ThemeHook";
import { useUser } from "../../../User/User.hook";
import getConfig from "next/config";
import { ModalState, ModalStatus } from "./type";
import IcBuscaPorTi from "shared-components/Components/PopUps/IcBuscaPorTi/web";
import { QuestionIcon } from "shared-components/Components/CustomIcons/QuestionIcon/web";
import "./styles.less"

const { NODE_ENV } = getConfig().publicRuntimeConfig;

const { useBreakpoint } = Grid;

interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
	onlyConsult?: boolean;
	queryRouter?: string;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

export const TextForm = ({
	id,
	onComplete = null,
	mode,
	disabled = false,
	defaultMessage = "",
	isInListing = false,
	showCTA = false,
	onlyConsult = false,
	queryRouter,
	isProjectSpecialPage = false,
	slug = "",
	projectId = null,
	isFromPaidTraffic = null,
	isProject = false
}) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const Router = useRouter();

	const { user } = useUser();
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	const bell = useRef(null);
	const [modalState, setModalState] = useState<ModalStatus>({
		similarModal: ModalState.DEFAULT,
		contactLead: ModalState.DEFAULT,
	}); const [isLoading, setIsLoading] = useState(false);
	const [formType, setFormType] = useState<number>(0);
	const [show, setShow] = useState(false);
	const [formData, setFormData] = useState({
		name: "",
		phone: "",
		email: "",
		message: "",
		busca_por_ti: false
	});
	const [errors, setErrors] = useState({
		name: false,
		phone: false,
		email: false,
		message: false,
	});

	// Simula el click de CTA "Avisame cuando baje de precio"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "bell") {
				if (bell.current) bell.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	const openModal = (type: number = 0) => {
		if (onComplete) onComplete();

		setFormType(type);
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.OPEN }));
	};

	const screen = useBreakpoint();

	const {
		contactMutation,
		sendContact,
		resetForm,
		error,
		formCompleted,
		disabledEmail,
		dataRegisterMutation,
		dataUserExist,
		updateUser,
		doContactMutation,
		leadID,
		isSendedConsultation
	} = useContact({
		id,
		onComplete: openModal,
		type: "lead",
		mode,
		source: isInListing ? 22 : screen.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const FP = useFacebookPixel();

	const reset = () => {
		resetForm();

		setFormData({
			name: user.data?.me?.name ?? "",
			phone: user.data?.me?.phone ?? "",
			email: user.data?.me?.email ?? "",
			busca_por_ti: false,
			message: "",
		});

		setIsLoading(false);
	};

	useEffect(() => {
		Router.events.on("routeChangeStart", reset);

		return () => Router.events.on("routeChangeStart", reset);
	}, []);

	useEffect(() => {
		if (user.data) {
			setFormData({
				...formData,
				name: user.data?.me?.name ?? "",
				phone: user.data?.me?.phone ?? "",
				email: user.data?.me?.email ?? "",
				message: defaultMessage
			})
		}
	}, [user.data]);

	// Aqui capturo los errores de la query de userExistsQuery
	useEffect(() => {
		if (error && error.message.includes("ya se encuentra registrada")) {
			handleClickShowNotification({
				message: error.message,
				type: "error",
			});

			setIsLoading(false);
		}
	}, [error]);

	useEffect(() => {
		if (formCompleted) {
			const categoryName: string = "formulario";

			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (dataUserExist) {
			openAuthModal({
				withPromise: true,
				email: formData.email,
			})
				.then(_ => {
					setCurrentUser(formData.name, formData.phone);
				})
				.catch(_ => {
					setIsLoading(false);
				});
		}
	}, [dataUserExist]);

	const setCurrentUser = (name: string, phone: string, type: number = 0) => {
		updateUser({
			name: name,
			phone: phone,
		}).then(_ => {
			doContactMutation(type);
		});
	};

	const setTypeCTA = (type: number) => {
		doContactMutation(type);
	};

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, { expires: 365 });
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const UY_TELEPHONE = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$/;
	const BR_TELEPHONE = /^[0-9]{10,11}$/;

	const submitForm = () => {
		if (isFormFilled()) {
			setFormData(prev => ({
				...prev,
				name: prev.name.trim(),
				message: prev.message.trim(),
				isFromPaidTraffic: isFromPaidTraffic,
				isSendingConsultation: true
			}))

			sendContact({ ...formData });
			setIsLoading(true);

			if (isProjectSpecialPage && slug && projectId) {
				let host = window.location.host;
				let TEST_HOST = "xn--4v8h.infocasas.com.uy";
				if (host === TEST_HOST || host === "localhost:3000") {
					host = "beta.infocasas.com.uy";
				}
				let reqEndpoint = `https://${host}/?mid=proyectos&func=landingDinamica&slug=${slug}&formulario&IDproyecto=${projectId}&json&nl`;
				let body = {
					nombre: formData.name,
					email: formData.email,
					tel: formData.phone,
					extra: formData.message,
					extra_completo: `${formData.message}.slug:${slug}`,
					InfoLeads: 1,
				};

				fetch(reqEndpoint, {
					method: "POST",
					body: JSON.stringify(body),
				}).then(res => {
					console.log(res)
				});
			}
		} else {
			if (formData.name === "") setErrors({ ...errors, name: true });
			if (formData.email === "") setErrors({ ...errors, email: true });
			if (formData.phone === "") setErrors({ ...errors, phone: true });
			if (formData.message === "") setErrors({ ...errors, message: true });
		}
	};

	const onCancelSimilarsLead = () => {
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.CLOSE, contactLead: ModalState.DEFAULT }));
		reset();
	};

	const onSendSimilarsLead = propertyIds => {
		const values = {
			email: formData.email ? formData.email : 'invitado@mail.com',
			mensaje: 'Hola, vi esta propiedad en InfoCasas y quiero que me contacten. Gracias.',
			nombre: formData.name ? formData.name : 'Invitado',
			telefono: formData.phone ? formData.phone : '999999999',
		}
		const leads = [...propertyIds].map(property_id => {
			const input: ContactInput = {
				property_id,
				message: values.mensaje,
				type: "PROPERTY",
				source: 11,
			};

			if (
				Router.query.utm_campaign ||
				Router.query.utm_content ||
				Router.query.utm_medium ||
				Router.query.utm_source
			) {
				input.utm_args = {};
				if (Router.query.utm_campaign) {
					input.utm_args.utm_campaign = Router.query.utm_campaign;
				}
				if (Router.query.utm_content) {
					input.utm_args.utm_content = Router.query.utm_content;
				}
				if (Router.query.utm_medium) {
					input.utm_args.utm_medium = Router.query.utm_medium;
				}
				if (Router.query.utm_source) {
					input.utm_args.utm_source = Router.query.utm_source;
				}
			}

			return contactMutation({
				variables: {
					input,
				},
			});
		});

		Promise.all(leads)
			.then(_ => {
				handleClickShowNotification({ message: "¡Tu consulta fue enviada con éxito!" });
			})
			.catch(err => {
				handleClickShowNotification({
					message: "Ha ocurrido un error",
					description: "Hubo un error. Vuelva a intentarlo.",
					type: "error",
				});
			})
			.finally(() => {
				setModalState((prevState) => ({ ...prevState, similarModal: ModalState.CLOSE }));
				reset();
			});
	};

	const handleShowModal = (e, showModal) => {
		e.preventDefault();
		setShow(showModal)
	}

	const MessageSuccessfull = ({ message, checkcircle = false }) => {
		return (
			<>
				{checkcircle ? (
					<Row justify={"center"} style={{ textAlign: "center" }}>
						<Col span={24}>
							<CheckCircleTwoTone
								twoToneColor="#52c41a"
								style={{ fontSize: "25px" }}
							/>
						</Col>
					</Row>
				) : (
					<Typography.Title
						level={4}
						style={{
							color: theme.colors.successColor,
							margin: 0,
							textAlign: "center",
						}}>
						{"Consulta Enviada"}
					</Typography.Title>
				)}

				<Typography.Text
					style={{ textAlign: "center", width: "100%", display: "block" }}
					strong={checkcircle}>
					{message}
				</Typography.Text>
			</>
		);
	};

	const isValidPhone = (str: string): boolean => {
		const regex = country_code === "BR" ? BR_TELEPHONE : UY_TELEPHONE;
		return regex.test(str);
	};

	const isValidEmail = (str: string): boolean => {
		const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
		return emailRegex.test(str);
	};

	const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: string) => {
		const value = e.target.value;

		if (fieldName === 'name') {
			const isValid = value.trim() !== '' && isValidCharactersXSS(value);
			setErrors({ ...errors, name: !isValid });
		} else if (fieldName === 'phone') {
			const isValid = value.trim() !== '' && isValidPhone(value);
			setErrors({ ...errors, phone: !isValid });
		} else if (fieldName === 'email') {
			const isValid = value.trim() !== '' && isValidEmail(value);
			setErrors({ ...errors, email: !isValid });
		} else if (fieldName === 'message') {
			const isValid = value.trim() !== '' && isValidCharactersXSS(value);
			setErrors({ ...errors, message: !isValid });
		}
	};

	const isFormFilled = () => {
		if (
			formData.name !== "" &&
			formData.email !== "" &&
			formData.phone !== "" &&
			formData.message !== ""
		) return true;
		else return false;
	}

	return (
		<>
			{show && <IcBuscaPorTi onClose={handleShowModal} showButtons={false} />}

			<form className="contact-form">
				<div className="row">
					<div className="container-input">
						<input
							className={"contact-form-input " + (errors.name ? "error" : "")}
							name="nombre"
							placeholder="Nombre"
							disabled={disabled}
							value={formData.name}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, name: e.target.value })}
							onBlur={(e) => handleBlur(e, 'name')}
							required
						></input>
						{errors.name && <span className="error-message">Nombre no válido</span>}
					</div>

					<div className="container-input">
						<input
							className={"contact-form-input " + (errors.phone ? "error" : "")}
							name="telefono"
							placeholder="Teléfono"
							disabled={disabled}
							value={formData.phone}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, phone: e.target.value })}
							onBlur={(e) => handleBlur(e, 'phone')}
							required
						></input>
						{errors.phone && <span className="error-message">Teléfono no válido</span>}
					</div>
				</div>
				<div className="container-input">
					<input
						className={"contact-form-input " + (errors.email ? "error" : "")}
						name="email"
						type="email"
						placeholder="Email"
						disabled={disabledEmail || disabled}
						value={formData.email}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, email: e.target.value })}
						onBlur={(e) => handleBlur(e, 'email')}
						required
					></input>
					{errors.email && <span className="error-message">Email no válido</span>}
				</div>

				<textarea
					className={errors.message ? "error" : ""}
					placeholder={"Escribe tu consulta"}
					disabled={disabled}
					value={formData.message}
					onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFormData({ ...formData, message: e.target.value })}
					onBlur={(e) => handleBlur(e, 'message')}
					required
				></textarea>
				{errors.message && <span className="error-message">Mensaje no válido</span>}

				{country_code !== "BR" && country_code !== "ce3" && !isProject && (
					<div className="container-busca-por-ti">
						<input
							className="styled-checkbox"
							type="checkbox"
							value="first_checkbox"
							disabled={disabled}
							id="checkbox-busca-por-ti"
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, busca_por_ti: e.target.checked })}
						/>
						<label htmlFor="checkbox-busca-por-ti">Quiero que InfoCasas busque por mí</label>

						<button onClick={(e) => handleShowModal(e, true)} className="info-btn">
							<QuestionIcon width={20} height={20} />
						</button>
					</div>
				)}

				<LeadButtons
					id={id}
					mode={mode}
					disabled={disabled}
					queryRouter={queryRouter}
					forceState={modalState.contactLead}
					onPhoneClick={() => {
						setModalState(prevState => ({
							...prevState,
							similarModal: ModalState.OPEN,
							contactLead: ModalState.CLOSE
						}));
					}}
					onWpClick={() => {
						setModalState(prevState => ({
							...prevState,
							similarModal: ModalState.OPEN,
							contactLead: ModalState.CLOSE
						}));
					}}
					onlyConsult={onlyConsult}>
					<Button
						type="primary"
						loading={isLoading}
						disabled={
							formCompleted || disabled || isSendedConsultation.sendConsultation
						}
						className="btn-send-lead"
						onClick={submitForm}>
						{formCompleted
							? "Enviado"
							: isLoading
								? "Enviando"
								: "Enviar Consulta"}
					</Button>
				</LeadButtons>
			</form>

			{showCTA && country_code !== "BR" && (
				<>
					<Row gutter={12}>
						<Col span={24}>
							{country_code !== "ce3" && (
								<Button
									ref={bell}
									htmlType="button"
									icon={<DollarOutlined className="cta-share-icon" />}
									className="btn-send-cta secondary"
									onClick={() => setTypeCTA(1)}
									disabled={disabled || isSendedConsultation.lowerPrice}>
									{"Avisame cuando baje de precio"}
								</Button>
							)}
							<Button
								htmlType="button"
								icon={
									country_code === "ce3" ? (
										<PhoneFilled className="cta-share-icon" />
									) : (
										<PhoneOutlined className="cta-share-icon" />
									)
								}
								className="btn-send-cta secondary"
								onClick={_ => setTypeCTA(2)}
								disabled={disabled || isSendedConsultation.wantedCall}>
								{"Quiero que me llamen"}
							</Button>
							{country_code !== "ce3" && (
								<Button
									htmlType="button"
									icon={<CalendarOutlined className="cta-share-icon" />}
									className="btn-send-cta secondary"
									onClick={_ => setTypeCTA(3)}
									disabled={disabled || isSendedConsultation.scheduleVisit}>
									{"Agendar Visita"}
								</Button>
							)}
						</Col>
					</Row>
				</>
			)}

			{modalState.similarModal == ModalState.OPEN && (
				<>
					<RTBhouse page="ficha" data={[leadID, id]} />
					<Modal
						className="similar-lead-modal"
						visible
						onCancel={onCancelSimilarsLead}
						width={formType || isInListing ? 420 : 1024}
						maskClosable={false}
						keyboard={false}
						footer={null}>
						{formType || isInListing ? (
							<MessageSuccessfull
								message={
									isInListing
										? "¡Tu mensaje fue enviado al anunciante!"
										: "¡Consulta express enviada con éxito!"
								}
								checkcircle
							/>
						) : (
							<SimilarsLead
								id={id}
								mode={mode}
								onSend={onSendSimilarsLead}
								onCancel={onCancelSimilarsLead}
							/>
						)}
					</Modal>
				</>
			)}
		</>
	);
};









